/**
 * The telecaller proxy endpoints (server/telecaller/*). Identity is the signed-in
 * user's ID token (X-Id-Token via authHeaders); every permission is checked server-side.
 */
export async function tcApi(path, opts = {}) {
    const PROXY = (import.meta.env?.VITE_PROXY_URL || (import.meta.env?.DEV ? 'http://localhost:3001' : '')).replace(/\/$/, '');
    const { authHeaders } = await import('../../../core/api/authHeaders');
    const headers = { ...(await authHeaders()), ...(opts.body ? { 'Content-Type': 'application/json' } : {}) };
    const r = await fetch(`${PROXY}${path}`, { ...opts, headers, body: opts.body ? JSON.stringify(opts.body) : undefined });
    const j = await r.json().catch(() => ({}));
    if (!r.ok || j.ok === false) throw new Error(j.error || `Request failed (${r.status})`);
    return j;
}

/** Download a file-returning telecaller endpoint (e.g. a CSV export) with the same auth. */
export async function tcDownload(path, filename) {
    const PROXY = (import.meta.env?.VITE_PROXY_URL || (import.meta.env?.DEV ? 'http://localhost:3001' : '')).replace(/\/$/, '');
    const { authHeaders } = await import('../../../core/api/authHeaders');
    const r = await fetch(`${PROXY}${path}`, { headers: { ...(await authHeaders()) } });
    if (!r.ok) {
        const j = await r.json().catch(() => ({}));
        throw new Error(j.error || `Download failed (${r.status})`);
    }
    const blob = await r.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

/** Today in India time, "YYYY-MM-DD" (+/- whole days). */
export const istDay = (offsetDays = 0) => new Date(Date.now() + 5.5 * 3600000 + offsetDays * 86400000).toISOString().slice(0, 10);

export const rupees =(n) => `₹${Math.round(Number(n) || 0).toLocaleString('en-IN')}`;
export const MANAGER_ROLES = new Set(['admin', 'super_admin', 'manager']);
export const isTcManager = (role) => MANAGER_ROLES.has(String(role || '').toLowerCase());
